import { render, staticRenderFns } from "./ReplaceShippingLeadTimeStep1.vue?vue&type=template&id=3d8da522&scoped=true&"
import script from "./ReplaceShippingLeadTimeStep1.vue?vue&type=script&lang=js&"
export * from "./ReplaceShippingLeadTimeStep1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8da522",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VForm,VRow})
